import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { ICompanyBase } from '@/types'
import { NoContent } from '@components-v2/atoms/NoContent'
import { StartUpCard } from '@components-v2/molecules/StartUpCard'
import styles from './index.module.scss'

type Props = {
  items: ICompanyBase[]
}

export const StartUpCardList: FC<Props> = ({ items = [] }) => {
  const { t } = useTranslation(['angels-vcs-startups'])
  if (items.length === 0) {
    return (
      <NoContent>
        {t('スタートアップ')}
        {t('がまだ登録されていません。')}
      </NoContent>
    )
  }
  return (
    <div className={styles.container}>
      {items.map((item) => (
        <StartUpCard key={item.slug} item={item} />
      ))}
    </div>
  )
}
